import { css } from 'styled-components';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { colorsV2 } from '../../colors-v2';

export const commonStyles = css`
  * {
    &::selection {
      background: #6a94ff33;
      color: ${colorsV2.neutral180};
    }
  }

  h2 {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    color: ${colorsV2.neutral180};

    ${fromScreen(451)} {
      font-size: 28px;
      line-height: 36px;
    }
  }

  h3 {
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    color: ${colorsV2.neutral180};

    ${fromScreen(451)} {
      font-size: 22px;
      line-height: 28px;
    }
  }

  h4 {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    color: ${colorsV2.neutral180};
  }

  p {
    font-size: 16px;
    line-height: 28px;
    color: ${colorsV2.neutral180};
  }

  blockquote {
    p {
      font-family: noto-serif, serif;
      font-size: 20px;
      line-height: 160%;
    }
  }
`;

export const spacingStyles = css`
  > * {
    margin-bottom: 0;

    & + * {
      margin-top: 20px;
    }

    & + p {
      margin-top: 16px;
    }

    & + h2 {
      margin-top: 32px;
    }

    & + h3 {
      margin-top: 24px;
    }

    & + h4 {
      margin-top: 16px;
    }

    ${fromScreen(451)} {
      & + * {
        margin-top: 24px;
      }

      & + p {
        margin-top: 16px;
      }

      & + h2 {
        margin-top: 48px;
      }

      & + h3 {
        margin-top: 32px;
      }

      & + h4 {
        margin-top: 16px;
      }
    }
  }

  h2 {
    & + * {
      margin-top: 20px;
    }

    & + p {
      margin-top: 16px;
    }

    & + h3 {
      margin-top: 20px;
    }

    ${fromScreen(451)} {
      & + * {
        margin-top: 24px;
      }

      & + p {
        margin-top: 16px;
      }

      & + h3 {
        margin-top: 24px;
      }
    }
  }

  h3 {
    & + * {
      margin-top: 16px;
    }

    & + p {
      margin-top: 12px;
    }

    & + h4 {
      margin-top: 16px;
    }

    ${fromScreen(451)} {
      & + * {
        margin-top: 20px;
      }

      & + p {
        margin-top: 12px;
      }

      & + h4 {
        margin-top: 16px;
      }
    }
  }

  h4 {
    & + * {
      margin-top: 16px;
    }

    & + p {
      margin-top: 8px;
    }
  }

  p {
    & + * {
      margin-top: 16px;
    }

    & + h2 {
      margin-top: 32px;
    }

    & + h3 {
      margin-top: 24px;
    }

    & + h4 {
      margin-top: 16px;
    }

    ${fromScreen(451)} {
      & + * {
        margin-top: 16px;
      }

      & + h2 {
        margin-top: 48px;
      }

      & + h3 {
        margin-top: 32px;
      }

      & + h4 {
        margin-top: 16px;
      }
    }
  }

  ul, ol {
    li + li {
      margin-top: 4px;
    }

    & + p {
      margin-top: 8px;
    }
  }

  table {
    ul, ol {
      li + li {
        margin-top: 0;
      }
    }
  }
`;
